import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import logo from "../images/lq-logo.svg";
import instagramIcon from "../images/instagram.png";

const CopyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
    <rect x="1" y="1" width="28" height="28" rx="5" stroke="white" strokeWidth="2" />
    <rect x="13" y="13" width="28" height="28" rx="5" fill="#001233" stroke="white" strokeWidth="2" />
  </svg>
);

const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
    <rect x="1" y="7" width="40" height="28" rx="5" stroke="white" strokeWidth="2" />
    <path d="M1 12L21 24L41 12" stroke="white" strokeWidth="2" strokeLinejoin="round" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1_908" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
      <path d="M0.696038 15.9325C0.696038 15.932 0.696038 15.933 0.696038 15.9325V15.9325ZM0.696038 15.9325C0.695234 18.6396 1.40257 21.2831 2.74769 23.6129L0.567383 31.574L8.71428 29.4379C10.9589 30.6612 13.486 31.3068 16.0579 31.3077H16.0648C24.5344 31.3077 31.4289 24.4155 31.4325 15.9444C31.4342 11.8395 29.837 7.97959 26.9352 5.07565C24.034 2.17184 20.1754 0.571824 16.0643 0.569946C7.59414 0.569946 0.700331 7.46235 0.696038 15.9325Z" fill="black" />
    </mask>
    <g mask="url(#mask0_1_908)">
      <rect x="0.567383" y="0.569946" width="30.8668" height="31.0041" fill="url(#paint0_linear_1_908)" />
    </g>
    <mask id="mask1_1_908" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="33">
      <path d="M5.16366 23.4742L4.84839 22.9734C3.52273 20.8655 2.82285 18.4295 2.82399 15.9281C2.82681 8.62872 8.76722 2.69032 16.072 2.69032C19.6095 2.69173 22.934 4.07056 25.4346 6.57283C27.9349 9.07491 29.3108 12.4013 29.3098 15.9388C29.3067 23.2384 23.366 29.1777 16.0671 29.1777H16.0619C13.6852 29.1764 11.3544 28.5384 9.32156 27.3319L8.83772 27.0453L3.82551 28.3594L5.16366 23.4742ZM16.067 0C7.28447 0 0.137292 7.14496 0.133734 15.927C0.13266 18.7342 0.866249 21.4746 2.26045 23.8901L0 32.1435L8.44645 29.9287C10.7736 31.1979 13.3937 31.8667 16.0601 31.8677H16.067C24.8481 31.8677 31.9962 24.7216 32 15.9399C32.0015 11.6837 30.3456 7.68184 27.3376 4.67115C24.3292 1.66066 20.3289 0.00194693 16.067 0Z" fill="black" />
    </mask>
    <g mask="url(#mask1_1_908)">
      <rect width="32.0015" height="32.1435" fill="url(#paint1_linear_1_908)" />
    </g>
    <mask id="mask2_1_908" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="33">
      <rect width="32" height="32.1435" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask2_1_908)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0848 9.26874C11.7866 8.60585 11.4727 8.59249 11.189 8.58087C10.9569 8.57094 10.6912 8.57154 10.426 8.57154C10.1606 8.57154 9.72923 8.67124 9.36449 9.06963C8.99954 9.468 7.97095 10.4311 7.97095 12.3897C7.97095 14.3487 9.39764 16.2412 9.59651 16.5071C9.79556 16.7726 12.3507 20.9204 16.3971 22.5162C19.7601 23.8424 20.4445 23.5786 21.1744 23.5123C21.9044 23.4459 23.5299 22.5494 23.8616 21.6198C24.1934 20.6903 24.1934 19.8936 24.0939 19.727C23.9943 19.5611 23.7289 19.4616 23.3307 19.2625C22.9326 19.0634 20.9754 18.1001 20.6104 17.9674C20.2454 17.8348 19.9799 17.7684 19.7146 18.1669C19.4491 18.5651 18.6866 19.4616 18.4543 19.7271C18.2221 19.9931 17.9899 20.0263 17.5917 19.8272C17.1935 19.6275 15.9113 19.2075 14.3902 17.8513C13.2067 16.7962 12.4078 15.4931 12.1754 15.0946C11.9432 14.6963 12.1506 14.4807 12.3503 14.2822C12.5291 14.1039 12.7484 13.8175 12.9475 13.585C13.1462 13.3526 13.2126 13.1866 13.3453 12.9212C13.4779 12.6553 13.4116 12.4228 13.3121 12.2238C13.2126 12.0247 12.4388 10.0558 12.0848 9.26874Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_1_908" x1="8.28409" y1="8.32097" x2="8.28409" y2="8.32097" gradientUnits="userSpaceOnUse">
        <stop offset="1" stopColor="#60D66A" />
        <stop stopColor="#20B038" />
      </linearGradient>
      <linearGradient id="paint1_linear_1_908" x1="8.00037" y1="8.03587" x2="8.00037" y2="8.03587" gradientUnits="userSpaceOnUse">
        <stop offset="1" stopColor="white" />
        <stop stopColor="#F9F9F9" />
      </linearGradient>
    </defs>
  </svg>
);

const FacebookIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1_911" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
      <rect width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1_911)">
      <path d="M32 16C32 7.16346 24.8365 0 16 0C7.1634 0 0 7.16346 0 16C0 23.9861 5.85096 30.6054 13.5 31.8057V20.625H9.43747V16H13.5V12.475C13.5 8.46498 15.8887 6.25002 19.5435 6.25002C21.294 6.25002 23.125 6.5625 23.125 6.5625V10.5H21.1074C19.1199 10.5 18.5 11.7334 18.5 12.9987V16H22.9375L22.2282 20.625H18.5V31.8057C26.149 30.6054 32 23.9861 32 16Z" fill="#1877F2" />
      <path d="M22.2281 20.625L22.9375 16H18.5V12.9986C18.5 11.7333 19.1198 10.5 21.1075 10.5H23.125V6.56248C23.125 6.56248 21.294 6.25 19.5434 6.25C15.8887 6.25 13.5 8.46496 13.5 12.475V16H9.4375V20.625H13.5V31.8056C14.327 31.9352 15.1629 32.0002 16 32C16.8505 32 17.6854 31.9334 18.5 31.8056V20.625H22.2281Z" fill="white" />
    </g>
  </svg>
);

const Instagram = () => <img src={instagramIcon} alt="Instagram" width="32" height="32" />;

const ShareModal = ({ shareModal, setShareModal }) => {
  const [copied, setCopied] = useState(false);
  const url = window.location.href;

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleInstagramShare = async () => {
    await navigator.clipboard.writeText(url);
    window.open("https://www.instagram.com", "_blank");
  };

  const shareItems = [
    {
      icon: <CopyIcon />,
      label: copied ? "Copied!" : "Copy link",
      action: handleCopyLink,
    },
    {
      icon: <EmailIcon />,
      label: "Email",
      action: () => window.open(`mailto:?subject=Listen Queer&body=${encodeURIComponent(url)}`),
    },
    {
      icon: <WhatsAppIcon />,
      label: "WhatsApp",
      action: () => window.open(`https://wa.me/?text=${encodeURIComponent(url)}`),
    },
    {
      icon: <FacebookIcon />,
      label: "Facebook",
      action: () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`),
    },
    {
      icon: <Instagram />,
      label: "Instagram",
      action: handleInstagramShare,
    },
  ];

  return (
    <Modal fullscreen={true} id="share-modal" className="share-modal" show={shareModal} onHide={() => setShareModal(false)}>
      <Modal.Body className="p-4 d-flex flex-column">
        <div className="d-flex justify-content-between align-items-start">
          <img src={logo} alt="Listen Queer" style={{ maxWidth: 180, filter: "brightness(0) invert(1)" }} />
          <button className="share-modal-close" onClick={() => setShareModal(false)}>
            <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.0469 14.162L14.1629 12.046L26.243 24.1261L24.127 26.2421L12.0469 14.162Z" fill="#F8F3FF" />
              <path d="M0 2.11707L2.11568 0.000689033L14.1636 12.0447L12.0479 14.1611L0 2.11707Z" fill="#F8F3FF" />
              <path d="M0 24.125L12.0652 12.0638L14.1809 14.1801L2.11569 26.2414L0 24.125Z" fill="#F8F3FF" />
              <path d="M12.0635 12.0634L24.1269 -3.19384e-05L26.2427 2.11583L14.1793 14.1792L12.0635 12.0634Z" fill="#F8F3FF" />
            </svg>
          </button>
        </div>

        <div className="share-bottom">
          <h2 style={{ color: "#fff", fontSize: 32 }}>Share the app</h2>
          <hr className="share-divider" />

          <ul className="share-list">
            {shareItems.map((item, i) => (
              <li key={i}>
                <button onClick={item.action}>
                  <span className="share-icon">{item.icon}</span>
                  <span className="share-label">{item.label}</span>
                </button>
                <hr className="share-divider" />
              </li>
            ))}
          </ul>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShareModal;
